import React, { Component } from 'react'
import DataWrapper from '../../../principal/containers/DataWrapper'
import { inject, observer } from 'mobx-react'
import FiltrosDirecionamento from '../components/FiltrosDirecionamento'
import TabelaDirecionamentoRecinto from '../components/TabelaDirecionamentoRecinto'
import DirecionamentoRecintoStore from '../stores/DirecionamentoRecintoStore'
import { Container, Row, Col, Button } from 'reactstrap'
import Footer from '../../../comum/components/Footer'
import FooterContent from '../../../comum/components/FooterContent'
import FooterOptions from '../../../comum/components/FooterOptions'
import IconButton from '../../../comum/components/IconButton'
import IncluirDirecionamento from '../components/IncluirDirecionamento'
import ImportarDirecionamento from '../components/ImportarDirecionamento'
import { makePDF } from '../../../../utils/formatar'
import ExportarExcelDirecionamento from '../components/ExportarExcelDirecionamento'
import ModalForm from '../../../comum/components/ModalForm'
import TabelaAdicoesDirecionamento from '../components/TabelaAdicoesDirecionamento'
import { IconeCarregar, IconeFechar } from '../../../comum/components/Icones'
import ModalAviso from '../../../comum/components/ModalAviso'
import FiltrosVisualizacaoAdicionar from '../components/FiltrosVisualizacaoAdicionar'

@inject("store")
@DataWrapper
@observer
export class DirecionamentoRecinto extends Component {

    constructor(props){
        super(props)

        super(props)
        this.tituloPaginaStore = this.props.store.tituloPaginaStore

        this.controller = new DirecionamentoRecintoStore()
        
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Direcionamento Recinto")
    }

    modalAdicionar() {
        return this.controller.modalAdicionar && <IncluirDirecionamento controller={this.controller} />
    }

    modalImportar() {
        return this.controller.modalImportar && <ImportarDirecionamento controller={this.controller} />
    }

    modalInativar() {
        if (this.controller.modalInativar)
            return <ModalForm labelCancelar="NÃO"
                                labelConfirmar="SIM"
                                salvando={this.controller.inativandoLoading}
                                onClickCancelar={ () => this.controller.cancelaInativar() }
                                onClickSalvar={ () => this.controller.confirmarInativar() }>
                { this.controller.listaSelecionados.length === 1
                    ? <h2>Deseja inativar o direcionamento selecionado?</h2>
                    : <h2>Deseja inativar os direcionamentos selecionados?</h2>
                }
            </ModalForm>
    }

    modalMensagem() {
        if(this.controller.mensagem !== "") {
            return (
                <ModalAviso
                    onClickFechar={this.controller.fecharModalMensagem}
                >
                    <h2>
                        {this.controller.mensagem}
                    </h2>
                </ModalAviso>
            )
        }
    }

    renderFooterButtons() {
        if(this.controller.loadingSalvar) {
            return(
                <IconeCarregar tamanho="2x" />
            )
        }else if(this.controller.adicionando) {
            return(
                <React.Fragment>
                    <Button
                    onClick={this.controller.cancelarAdicao}
                    className="btn-primary"
                    >
                        CANCELAR
                    </Button>
                    <Button
                        onClick={this.controller.salvarNovosDirecionamentos}
                        className="btn-primary"
                    >
                        SALVAR
                    </Button>
                </React.Fragment>
            )
        }else {
            return(
                <Button
                    onClick={this.controller.abrirModalInativar}
                    className="btn-primary"
                    disabled={this.controller.listaSelecionados.length === 0}
                >
                    INATIVAR DIRECIONAMENTO
                </Button>
            )
        }
    }

    modalAdicionarAnexo() {
        return this.controller.modalAdicionarAnexo && <ModalForm
            labelConfirmar="CONFIRMAR"
            onClickSalvar={() => {
                // Eu preciso fazer essa modificação para que os dados dentro do Anexo fiquem como um array dentro do controller
                // E assim seja possível o MobX escutar o  que houve e renderizar a tela
                // Não fazendo isso eu teria de modificar ou criar funções específicas para o anexo, desta forma eu posso reutilizar estruturas
                this.controller.elementoEmEdicao.Anexo = [this.controller.elementoEmEdicao.Anexo]
                this.controller.alterarDadosEdicao(
                    this.controller.elementoEmEdicao.CeHouse,
                    this.controller.elementoEmEdicao.flagCarga,
                    this.controller.elementoEmEdicao.Container,
                    this.controller.elementoEmEdicao.Cnpj,
                    this.controller.elementoEmEdicao.RazaoSocial,
                    this.controller.elementoEmEdicao.Anexo
                )
                this.controller.fecharAdicionarAnexo()
                }
            }
            onClickCancelar={this.controller.fecharAdicionarAnexo}
        >
            <h2>Anexar arquivo</h2>
            { this.controller.elementoEmEdicao.Anexo
                ? <Col xs={12} md={12} className="mb-4">
                    <div className={`item-anexo`}>
                        <span>{`${this.controller.elementoEmEdicao.Anexo.name}`}</span>
                        <span className="ml-2">
                            <IconeFechar tamanho="lg" onClick={() => this.controller.removerAnexo()} />
                        </span>
                    </div>
                </Col>
                : <React.Fragment>
                    <input type="file" onChange={e => this.controller.anexarArquivo(e)} accept=".csv, .xml, .txt, .xls, .xlsx, .doc, .pdf" />
                </React.Fragment>
            }
        </ModalForm>
    }

    render() {
        const pdfData = this.controller.colunasExportar
        return (
            <div className="form-wrapper">
                { this.modalAdicionarAnexo() }
                { this.modalAdicionar() }
                { this.modalImportar() }
                { this.modalInativar() }
                { this.modalMensagem() }
                <Container fluid className="liberacao-cabotagem tela-botoes-inclusao-topo" >
                    <Row className="botoes-inclusao-topo">
                        <Col xs={12} sm={12} md={12}>
                            <Button onClick={() => this.controller.abrirModalAdicionar()} className="btn-com-bordas-primary">
                                Novo Direcionamento
                            </Button>
                            <Button onClick={() => this.controller.abrirModalImportar()} className="btn-com-bordas-cinza">
                                Importar Planilha
                            </Button>
                        </Col>
                    </Row>
                        {
                            this.controller.adicionando
                            ? <FiltrosVisualizacaoAdicionar controller={this.controller} />
                            : <FiltrosDirecionamento controller={this.controller} />
                        }
                        {
                            this.controller.adicionando
                            ? <TabelaAdicoesDirecionamento controller = {this.controller} />
                            : <TabelaDirecionamentoRecinto controller={this.controller} />
                        }
                </Container>
                <Footer>
                    <FooterContent>
                        {
                            this.controller.filtrado && !this.controller.adicionando
                            ?<React.Fragment>
                                {
                                    this.controller.listaSelecionados.length === 0
                                    ? <React.Fragment>
                                        <b className="mr-1">
                                            {this.controller.itens.length}
                                        </b>
                                        Direcionamentos encontrados
                                    </React.Fragment> 
                                    :<React.Fragment>
                                    <b className="mr-1">
                                        {this.controller.listaSelecionados.length}
                                    </b>
                                    Direcionamentos selecionados
                                </React.Fragment> 
                                }
                                -
                                <Button className="btn-primary px-0" onClick={this.controller.listarDirecionamentos}>Atualizar lista</Button>
                            </React.Fragment>
                            : null
                        }
                    </FooterContent>
                    <FooterOptions>
                        
                         <IconButton 
                            icon="file-pdf"
                            text="Baixar PDF"
                            size="md"
                            disabled={this.controller.listaDirecionamentos.length === 0}
                            onClick={() => makePDF(
                                this.controller.listaDirecionamentos,
                                pdfData.map(data => data.dataField),
                                pdfData.map(data => data.text),
                                ["DtImport","DtCancel"],
                                true,
                                false,
                                {nomeDoArquivo: "Direcionamento.pdf"}
                            )}
                         />
                         {/**
                         * TODO mudar para a operação de exportar XLS padrão
                         */}
                         <ExportarExcelDirecionamento controller={this.controller} />
                         
                    </FooterOptions>
                    <FooterContent className="right-pos">
                        { this.renderFooterButtons() }
                    </FooterContent>
                </Footer>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/direcionamento/recinto/telas/DirecionamentoRecinto.js